import { forwardRef, PropsWithChildren } from 'react';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';
import Popover, {
  InstanceRef,
  PopoverProps,
} from '@decisiv/ui-components/lib/components/Popover';
import Button from '@decisiv/ui-components/lib/components/Button';
import Grid from '@decisiv/ui-components/lib/components/Grid';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { ActionProps } from '@decisiv/ui-components/lib/atoms/OptionsList/types';

import { Container, CustomColumn, FullMoonRow } from './styles';

export type PopoverActions = { left: ActionProps[]; right: ActionProps[] };

export interface ActionsPopoverProps extends PopoverProps {
  width?: string;
  actions: PopoverActions;
}

const ActionsPopover = forwardRef<
  InstanceRef,
  PropsWithChildren<ActionsPopoverProps>
>(
  /* istanbul ignore next -- @preserve */
  (
    { actions, children, width = rem(spacing.base * 25), ...popOverProps },
    ref,
  ) => {
    return (
      <Popover manageEvents={false} ref={ref} {...popOverProps}>
        <Container width={width}>
          {children}
          <FullMoonRow>
            <CustomColumn>
              {actions?.left?.map((action) => (
                <Button key={action.id} size="small" {...action} />
              ))}
            </CustomColumn>
            <Grid.Column span="6">
              <Flex justifyContent="flex-end">
                {actions?.right?.map((action) => (
                  <Button key={action.id} {...action} size="small" />
                ))}
              </Flex>
            </Grid.Column>
          </FullMoonRow>
        </Container>
      </Popover>
    );
  },
);

ActionsPopover.displayName = 'ActionsPopover';

export default ActionsPopover;
